import { render, staticRenderFns } from "./springFActRewardPoolList.vue?vue&type=template&id=05783da6&scoped=true"
import script from "./springFActRewardPoolList.vue?vue&type=script&lang=ts"
export * from "./springFActRewardPoolList.vue?vue&type=script&lang=ts"
import style0 from "./springFActRewardPoolList.vue?vue&type=style&index=0&id=05783da6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05783da6",
  null
  
)

export default component.exports